module.exports = __webpack_public_path__ + "static/media/fragile.9761fe9e.svg";